import { GridItem } from '@bnnvara/grids';
import React from 'react';

import ArticleCard from '../../components/cards/ArticleCard';

const renderComposableArticlePortalCard = (item, index) => {
  const { slug: key } = item;

  if (index === 0) {
    return (
      <GridItem
        columnEndSm="span 12"
        columnEndMd="span 12"
        columnEndLg="span 6"
        columnEndXl="span 6"
      >
        <ArticleCard {...item} key={key} />
      </GridItem>
    );
  }

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 3"
      columnEndXl="span 3"
    >
      <ArticleCard {...item} key={key} />
    </GridItem>
  );
};

export default renderComposableArticlePortalCard;
